module.exports = __webpack_public_path__ + "footer-01.svg?15d3289dcd2ec0d640039921fdea7a26";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer-01.svg
// module id = 72
// module chunks = 0